import script from "./messageList.vue?vue&type=script&lang=ts&setup=true"
export * from "./messageList.vue?vue&type=script&lang=ts&setup=true"

import "./messageList.vue?vue&type=style&index=0&id=29570b9a&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29570b9a"]])

export default __exports__